(function() {
    'use strict';

    angular.module('product')
        .controller('ProductParameterListController', ProductParameterListController);

    ProductParameterListController.$inject = ['$state', 'productParameterDataSrvc', 'productParameterSrvc', 'notificationSrvc', 'lodashService', 'productParameterMessagesConst', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'productParameterPermissionsConst', 'filterQuerySrvc'];

    function ProductParameterListController($state, productParameterDataSrvc, productParameterSrvc, notificationSrvc, lodashService, productParameterMessagesConst, datatableDefaultPageSizeValueConst, checkSearchSrvc, productParameterPermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.productParameterRows = [];
        self.productParameterCols = [{
            title: 'ID',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nazwa zmiennej',
            value: 'var_name',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.modelPermissions = productParameterPermissionsConst;
        self.searchQuery = {
            pk: null,
            name: null,
            var_name: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;
        self.onReorder = onReorder;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getProductParameters();
        }

        function getProductParameters(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    pk: self.searchQuery.pk,
                    name: self.searchQuery.name,
                    var_name: self.searchQuery.var_name,
                    ordering: self.searchQuery.ordering
                };
            }
            return productParameterDataSrvc.list(filterObj).$promise.then(
                function(response) {
                    self.productParameterRows = response.results;
                    self.pageOpts.count = response.count;
                    return response;
                },
                function(response) {
                    if (response.status === 404 && filterObj.page !== 1) {
                        checkSearchSrvc.recall(filterObj, getProductParameters);
                    }
                }
            ).finally(
                function(response) {
                    self.loading = false;
                    return response;
                }
            );
        }

        function onCreate() {
            $state.go('layout.productParameter.create');
        }

        function onEdit(row) {
            $state.go('layout.productParameter.update', { pk: row.pk });
        }

        function onDelete(row) {
            return productParameterSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", productParameterMessagesConst.delete);
                lodashService.remove(self.productParameterRows, { pk: row.pk });
            }, function(response) {
                notificationSrvc.notification("error", response.data.data.non_field_errors[0]);
                return response;
            });
        }

        function onReorder(row, newPos) {
            return productParameterDataSrvc.update({
                pk: row.pk
            }, {
                position: newPos
            }).$promise.then(
                function(response) {
                    return response;
                },
                function(response) {
                    notificationSrvc.notification("error", productParameterMessagesConst.error);
                }
            );
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getProductParameters();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getProductParameters();
        }
    }
})();
